import { Component, AfterViewInit, OnDestroy } from '@angular/core';

declare global {
  interface Window {
    GiaChatbot: any;
  }
}

@Component({
  selector: 'app-chatbot',
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.css']
})
export class ChatbotComponent implements AfterViewInit, OnDestroy {
  private chatbot: any;
  private scriptEl: HTMLScriptElement | null = null;

  ngAfterViewInit(): void {
    if (window.GiaChatbot) {
      this.initChatbot();
      return;
    }
    this.scriptEl = document.createElement('script');
    this.scriptEl.src = '/assets/gia-chatbot.min.js';
    this.scriptEl.onload = () => this.initChatbot();
    this.scriptEl.onerror = () => console.error('[Chatbot] Failed to load gia-chatbot.min.js from /assets/');
    document.body.appendChild(this.scriptEl);
  }

  private initChatbot(): void {
    this.chatbot = window.GiaChatbot.init({
      backendUrl: 'https://staging-gia.gentari.co.in',
      ollamaUrl: 'https://staging-gia.gentari.co.in/ollama'
    });
  }

  ngOnDestroy(): void {
    if (this.chatbot && this.chatbot.destroy) {
      this.chatbot.destroy();
    }
  }
}
